export default class AddTab {
    constructor() {
        this.tabTemplate = '';
        this.tabPane = '';


        this.initialize();
    }


    addContent() {
        const that = this;
        const addTabButton = $('.js-add-tab');

        addTabButton.each(function () {
            const button = $(this);

            const section = $(this).closest('.js-tab-section');
            const languageId = section.data('language');
            const instanceId = section.data('instance');
            const productGroupId = section.data('product-group');
            const productId = section.data('product');
            const dropZone = section.find('.dropzone');

            const tabHeader = section.find('.js-document-tabs[data-language='+languageId+']');
            const activeInput = tabHeader.find('li a.active input[name=tab_name]');

            if(activeInput.length) {
                that._changeDropZoneAction(dropZone, languageId, productGroupId, productId, instanceId, activeInput.val());
            }

            button.on('click', function (e) {
                e.preventDefault();

                that.getTabContent(languageId, productGroupId);

                that._appendTab(section);
                that._appendTabPane(section);
                that._showUpload(languageId);
                that._changeDropZoneAction(dropZone, languageId, productGroupId, productId, instanceId);
                that._changeStatusOnFilesButton(true);
            });
        });
    }

    initialize() {
        this.getTabContent();
        this.addContent();
        this.checkTabValue();
        this.inputChanges();
    }

    _listenToInputChanges(callback) {
        $(document).on('keyup', '.js-document-tabs .nav-item input[type="text"]', function () {
            callback($(this));
        })
    }

    inputChanges() {
        const that = this;

        this._listenToInputChanges(function (input) {

            const section = input.closest('.js-tab-section');
            const languageId = section.data('language');
            const instanceId = section.data('instance');
            const productGroupId = section.data('product-group');
            const productId = section.data('product');
            const dropZone = section.find('.dropzone');
            const value = input.val();
            if (value.length > 0) {

                that._changeStatusOnFilesButton(false);
                that._changeDropZoneAction(dropZone, languageId, productGroupId, productId, instanceId, value);
                that._updateInputNames(input);
                that._updateTabIds(input);
            }
        })
    }


    getTabContent(languageId, productGroupId) {
        const that = this;

        $.ajax({
            url: '/ajax/tabContent',
            type: 'post',
            data: {
                "languageId": languageId,
                "productGroupId": productGroupId
            }
        }).done(function (resp) {
            that.tabTemplate = resp['tabTemplate'];
            that.tabPane = resp['tabPane'];
        })
    }

    _updateTabIds(input) {
        const section = input.closest('.js-tab-section');
        const parentLink = input.parent().attr('href').replace('#', '');
        input.parent().attr('href', '#' + input.val());
        let tabPane = section.find('.tab-pane[id="' + parentLink + '"]');
        tabPane.attr('id', input.val());
    }


    _updateInputNames(input) {
        const section = input.closest('.js-tab-section');
        const language = section.data('language');
        const parentLink = input.parent().attr('href').replace('#', '');
        let inputs = section.find('.tab-pane[id="' + parentLink + '"] input[type="text"]');
        inputs.each(function () {
            let inputName = `fileName[${language}][${input.val()}][${$(this).data('file')}]`;

            // let inputName = $(this).attr('name').replace(parentLink, input.val());
            $(this).attr('name', inputName)
        });
    }

    _showUpload(languageId) {
        $('.js-tabs-add-files-button[data-language="' + languageId + '"]').show();
    }

    _appendTab(section) {
        const tabList = section.find('ul.js-document-tabs');
        const tabItems = tabList.find('li');
        tabItems.find('a.active').removeClass('active');
        tabList.append(this.tabTemplate);
    }


    _changeDropZoneAction(dropZone, languageId, productGroupId, productId = null, instanceId = null, tabName = null) {
        $.ajax({
            url: '/ajax/dropZoneAction',
            type: 'post',
            data: {
                "languageId": languageId,
                "productId": productId,
                "productGroupId": productGroupId,
                "instanceId": instanceId,
                "tabName": tabName
            }
        }).done(function (resp) {
            dropZone.attr('action', resp);
        })
    }

    _appendTabPane(section) {
        const tabContent = section.find('.tab-content');
        tabContent.find('.tab-pane').removeClass('active');
        tabContent.append(this.tabPane);
    }

    checkTabValue() {
        const tabList = $(document).find('.js-document-tabs');
        const that = this;
        const tabs = tabList.find('a[data-toggle="tab"]');
        $(document).on('shown.bs.tab', '.js-document-tabs a[data-toggle="tab"]', function () {
            const inputVal = $(this).find('input[type="text"]').val();
            if (inputVal.length == 0) {
                that._changeStatusOnFilesButton(true);
            } else {
                that._changeStatusOnFilesButton(false);
            }
        });
    }

    _changeStatusOnFilesButton(value) {
        $('.js-tabs-add-files-button button').attr('disabled', value);
    }


}



// WEBPACK FOOTER //
// ./resources/assets/js/contentElements/tabs.js